module.exports = __webpack_public_path__ + "img/info.434906a4.svg";